// extracted by mini-css-extract-plugin
module.exports = {"reportChartHeader":"ReportGallery_reportChartHeader__1tsFP","reportListChart":"ReportGallery_reportListChart__3uDe0"};